'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  borderRadius: '50px',
  display: 'inline-block',
  margin: 0,
  overflow: 'hidden',
  padding: 0
};

var Paper = function Paper(_ref) {
  var children = _ref.children,
      color = _ref.color,
      diameter = _ref.diameter,
      styleOverrides = _ref.style;
  return _react2.default.createElement(
    'div',
    {
      className: 'paper',
      style: _extends({}, styles, {
        backgroundColor: color,
        height: diameter,
        width: diameter
      }, styleOverrides)
    },
    children
  );
};

Paper.propTypes = {
  color: _propTypes2.default.string,
  diameter: _propTypes2.default.number,
  style: _propTypes2.default.object
};

exports.default = Paper;